import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const response = await fetch('https://formspree.io/f/mbledajw', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          _replyto: formData.email,
          _subject: `New Contact Form: ${formData.subject}`
        }),
      });

      if (response.ok) {
        setIsSubmitting(false);
        setIsSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        
        // إعادة تعيين الرسالة بعد 5 ثواني
        setTimeout(() => setIsSubmitted(false), 5000);
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      setIsSubmitting(false);
      setError('Failed to send message. Please try again later.');
    }
  };

  return (
    <>
      {/* Hero Section */}
      <section className="page-hero">
        <div className="hero-content">
          <h1 data-fade>Contact Us</h1>
          <p data-fade data-delay="100">
            Get in touch with us - We'd love to hear from you
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact section-bg">
        <div className="container">
          <div className="section-title">
            <h2>Contact</h2>
            <p>Get In Touch</p>
          </div>

          <div className="contact-content">
            <div className="contact-info">
              <div className="info-item">
                <div className="info-box">
                  <i className="fas fa-map-marker-alt"></i>
                  <h3>Our Address</h3>
                  <p>Egypt - Bani Swif - Smsta</p>
                </div>
              </div>

              <div className="info-grid">
                <div className="info-item">
                  <div className="info-box">
                    <i className="fas fa-envelope"></i>
                    <h3>Email Us</h3>
                    <p>
                      export@realmofherbs.com<br />
                      ceo@realmofherbs.com<br />
                      support@realmofherbs.com<br />
                      sales@realmofherbs.com
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-box">
                    <i className="fas fa-phone"></i>
                    <h3>Call Us</h3>
                    <p>
                      +201221691637<br />
                      +201227479176
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form">
              <form onSubmit={handleSubmit} className="email-form">
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <input
                    type="text"
                    name="subject"
                    className="form-control"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="5"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="form-messages">
                  {isSubmitting && (
                    <div className="loading-message">
                      <i className="fas fa-spinner fa-spin"></i> Sending your message...
                    </div>
                  )}
                  {isSubmitted && (
                    <div className="success-message">
                      <i className="fas fa-check-circle"></i> Your message has been sent successfully! We'll get back to you soon.
                    </div>
                  )}
                  {error && (
                    <div className="error-message">
                      <i className="fas fa-exclamation-circle"></i> {error}
                    </div>
                  )}
                </div>

                <div className="text-center">
                  <button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i> Sending...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-paper-plane"></i> Send Message
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="social-links">
            <div className="social-box">
              <div className="social-icons">
                <a href="https://www.facebook.com/share/1BzQdX7m8Z/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook"></i>
                </a>
                <a href="https://www.linkedin.com/in/sherif-ibrahim-18a61b234" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://wa.me/201221691637" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;